import { Component, Input } from "@angular/core";
import { FilterModelDto } from "../../../../models/filter.model";

@Component({
  selector: "app-notification-page-filter",
  templateUrl: "./notification-page-filter.component.html",
  styleUrls: ["./notification-page-filter.component.scss"],
})
export class NotificationPageFilterComponent {
  @Input() filterStatuses: FilterModelDto[] | undefined;
  @Input() priorityStatuses: FilterModelDto[] | undefined;

  filterStart: FilterModelDto = {
    fieldName: "date_from",
    value: "",
    description: "",
  };

  filterEnd: FilterModelDto = {
    fieldName: "date_to",
    value: "",
    description: "",
  };
}
